/** Trigger a short haptic vibration on mobile devices. No-op on unsupported platforms. */
export const haptic = (ms = 50) => navigator.vibrate?.(ms);
